import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {InfluencerNote} from '../../../../models/influencer-note';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {InlineEditNoteComponent} from '../inline-edit-note/inline-edit-note.component';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '../../../services/modal/modal.service';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {CacheService} from '../../../services/cache/cache.service';
import { DateUtils } from '../../../utils/date.utils';
import { UserService } from '../../../services/user.service';
import { ObjectUtils } from '../../../utils/object.utils';

@Component({
  selector: 'add-notes',
  templateUrl: './add-notes.component.html',
  styleUrls: ['./add-notes.component.scss']
})
export class AddNotesComponent implements OnInit {
  readonly FAKE_NEW_NOTE_ID = 99999;
  @ViewChild('createNewNoteRef') createNewNoteRef: InlineEditNoteComponent;
  @ViewChild('NotificationNoteErrorProcessing') notificationNoteErrorProcessing: AchooPopupComponent;
  @Input()
  public influencerId: number;
  @Input()
  isReadOnly: boolean;

  public allowToAddNewNote = true;
  public newNote = new InfluencerNote();

  public notes: InfluencerNote[] = [];
  private previousNotes: InfluencerNote[] = [];

  public sampleNote = {
    id: 0,
    userId: 0,
    userName: this.translate.instant('note.sample_user'),
    companyId: 0,
    influencerId: 0,
    content: this.translate.instant('note.sample_content')
  };
  private isFetchingNotes = false;
  private isAddedNoteBefore = false;
  private currentUserInfo;

  constructor(private influencerService: InfluencerService,
              private modalService: ModalService,
              private cacheService: CacheService,
              private translate: TranslateService,
              private userService: UserService) { }

  ngOnInit() {
    this.loadListNote(this.influencerId);
    this.newNote.influencerId = this.influencerId;
    this.getCurrentUserInfo();
  }

  private getCurrentUserInfo() {
    this.userService.getCurrentUserInfo().subscribe(res => {
      if (res && res.data) {
        this.currentUserInfo = res.data;
      }
    });
  }

  loadListNote(influencerId) {
    this.isFetchingNotes = true;
    this.cacheService.get(`influencer_notes_${this.influencerId}`,
      this.influencerService.loadNoteListOfInfluencer(influencerId)).subscribe((res) => {
      this.isFetchingNotes = false;
      if (res && res.data) {
        this.notes = res.data.noteList;
        this.previousNotes = ObjectUtils.deepClone(this.notes);
        this.isAddedNoteBefore = res.data.haveAddedNote;
      }
    });
  }

  afterCreateOrUpdateNote(evt) {
    if (!evt.note) {
      return;
    }
    const noteData: InfluencerNote = {
      id: evt.note.id ? evt.note.id : null,
      userId: evt.note.userId,
      userName: evt.note.userName ? evt.note.userName : this.currentUserInfo.fullName,
      companyId: evt.note.companyId ? evt.note.companyId : this.currentUserInfo.company.id,
      influencerId: evt.note.influencerId ? evt.note.influencerId : this.influencerId,
      content: evt.note.content,
      createdAt: DateUtils.now(),
      modifiedAt: DateUtils.now(),
    };
    if (evt.isCreated) {
      // add faked id for new Note to show in UI immediately (Optimistic UI)
      const newAddedNote = Object.assign({}, noteData, {
        id: this.FAKE_NEW_NOTE_ID
      });
      this.notes.push(newAddedNote);
    }
    this.allowToAddNewNote = true;
    this.newNote.content = undefined;
    this.cacheService.clear(`influencer_notes_${this.influencerId}`);
    this.influencerService.createOrUpdateNote(noteData).subscribe((res) => {
      this.loadListNote(this.influencerId);
    }, (err) => {
      this.notes = this.previousNotes;
      this.onErrorHappen(evt);
    });
  }

  onErrorHappen(evt) {
    this.modalService.open(this.notificationNoteErrorProcessing, null, true);
  }

  afterDeleteNote(evt) {
    this.loadListNote(this.influencerId);
  }

  onAddNewNote() {
    this.allowToAddNewNote = false;
    setTimeout(() => {
      this.createNewNoteRef.contextBox.nativeElement.focus();
    }, 200);
  }

  cancelAddingNote() {
    this.allowToAddNewNote = true;
  }

  closeNotification() {
    this.modalService.close();
  }

  get showSuggestion() {
    return !this.isFetchingNotes && !this.isAddedNoteBefore;
  }

  deletedNote(evt) {
    this.notes = this.notes.filter(noteItem => noteItem.id !== evt);
    this.cacheService.clear(`influencer_notes_${this.influencerId}`);
    this.influencerService.deleteNote(evt).subscribe((res) => {
      this.loadListNote(this.influencerId);
    }, (err) => {
      this.notes = this.previousNotes;
      this.onErrorHappen(evt);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/add-notes/add-notes.component.ts